import axios from 'axios'
import ActionsLogin from './LoginActions'

const config = {
  headers: {
    Authorization: 'Bearer ' + ActionsLogin.getToken()
  }
}

const enviar = (status, uf) => {
  let data = {
    status_motorista: status,
    uf: uf
  }

  return axios.post(`${process.env.URL_API_MENSAGEM}/message/send-with-filter`, data, config)
}

export default {
  enviar
}



// WEBPACK FOOTER //
// ./src/actions/MensagemActions.js